import axios from "axios";
import {
  MARKETSTORE_LIST_ATTEMPT,
  MARKETSTORE_LIST_SUCCESS,
  MARKETSTORE_LIST_FAILED
} from "../types/marketstoreListTypes";
import { config } from "../../config";
const url_api = config.api.godiway;
export function loading() {
  return {
    type: MARKETSTORE_LIST_ATTEMPT
  };
}

export function success(data) {
  return {
    type: MARKETSTORE_LIST_SUCCESS,
    data: data
  };
}

export function failed(error) {
  return {
    type: MARKETSTORE_LIST_FAILED,
    error: error
  };
}

export const loadList = (data: Object) => async dispatch => {
  dispatch(loading());
  await axios
    .get(url_api + "marketstore", {
      params: {
        id: data.user_id,
      },
      headers: { authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};
